import { CommonModule, NgClass, NgFor, NgForOf, NgIf } from '@angular/common';
// import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
// import { FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
// import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/core/navigation/navigation.service';
// import { Navigation } from 'app/core/navigation/navigation.types';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { LanguagesComponent } from 'app/layout/common/languages/languages.component';
import { MessagesComponent } from 'app/layout/common/messages/messages.component';
import { NotificationsComponent } from 'app/layout/common/notifications/notifications.component';
import { QuickChatComponent } from 'app/layout/common/quick-chat/quick-chat.component';
import { SearchComponent } from 'app/layout/common/search/search.component';
import { ShortcutsComponent } from 'app/layout/common/shortcuts/shortcuts.component';
import { UserComponent } from 'app/layout/common/user/user.component';
import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
    AfterViewInit,
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import {
    FuseNavigationItem,
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { AppState, selectAuthState, selectPermisosState, selectUtilsState } from 'app/store/app.states';
import { Store } from '@ngrx/store';
import { SessionInitializer } from 'app/services/session-initializer';
import { BaseService } from 'app/services/base.service';
import { IModulo } from 'app/store/reducers/permisos.reducers';
import { isNull } from 'lodash';
import { SeleccionarEmpresa } from 'app/store/actions/utils.action';
import { environment } from 'environments/environment';
import { EstatusEmpresa } from 'app/shared/enum.shared';
import { CoalService } from 'app/services/coal.service';
import { EmpresaService } from './empresa-service.service';

@Component({
    selector: 'classy-layout',
    templateUrl: './classy.component.html',
    styleUrls: ['./classy.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        FuseLoadingBarComponent,
        FuseVerticalNavigationComponent,
        NotificationsComponent,
        UserComponent,
        CommonModule,
        MatIconModule,
        MatButtonModule,
        LanguagesComponent,
        FuseFullscreenComponent,
        SearchComponent,
        ShortcutsComponent,
        MessagesComponent,
        RouterOutlet,
        QuickChatComponent,
    ],
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    user: any;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    getState: Observable<any>;
    getUtilState: Observable<any>;
    getAuthState: Observable<any>;
    subsPermission: Subscription;
    subsUtil: Subscription;
    subsAuth: Subscription;
    breadcrumb: any;
    datosUsuario: any;
    state: any;
    objSeguridad: any[];
    empresas: any;
    isDropdownOpen: boolean = false;
    empresaSeleccionada: any;
    logoEmpresa: any;
    agregarEmpresa: boolean = false;
    facturasRestantes: number = 10; 
    /**
     * Constructor
     */
    constructor(
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private store: Store<AppState>,
        private cdref: ChangeDetectorRef,
        private sessionInitializer: SessionInitializer,
        private baseService: BaseService,
        private _userService: UserService,
        private _router: Router,
        private coalService: CoalService,
        private empresaService: EmpresaService
    ) {
        this.getState = this.store.select(selectPermisosState);
        this.getUtilState = this.store.select(selectUtilsState);
        this.getAuthState = this.store.select(selectAuthState);
    }
    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to navigation data
        this.getNavigation();
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
            });
        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                this.isScreenSmall = !matchingAliases.includes('md');
            });
        this.subsPermission = this.getState.subscribe((state) => {
            this.breadcrumb = null;
            this.breadcrumb = state.breadcrumb;
            this.cdref.detectChanges();
        });
        this.subsUtil = this.getUtilState.subscribe((state) => {
            this.empresaSeleccionada = state.empresaSeleccionada;
            if (state.empresaSeleccionada?.attributes.logo?.data?.attributes.url) {
                this.logoEmpresa = environment.hostBack + state.empresaSeleccionada?.attributes.logo?.data?.attributes.url;
            } else {
                // this.coalService.getService(`par-parametros?populate=*`)
                // .subscribe((res: any) => {
                //     res.data.forEach(element => {
                //         if (element.attributes.parametro == 'perfil_default') {
                //             this.logoEmpresa = environment.hostBack + element.attributes.archivo.data[0].attributes.url;
                //         }
    
                      
                //     });
    
                // }, (error: any) => {
                //     // this.store.dispatch(OcultarSpinner());
    
                // });
            }
        });
        this.subsAuth = this.getAuthState.subscribe((state) => {
            this.state = state
            this.empresas = state?.seguridad?.company;
            this.agregarEmpresa = this.empresas.find(x => x.attributes?.ope_empresa_estatus_hs?.data[0]?.attributes?.ope_empresa_estatus?.data?.id < EstatusEmpresa.RegistroCompleto) ? false : true;
        });

        // Verificar si ya hay una empresa seleccionada
        if (this.empresaSeleccionada) {
            this.empresaService.seleccionarEmpresa(this.empresaSeleccionada);
        }

        // Suscribirse al servicio para obtener el valor de facturas restantes
        this.empresaService.facturasRestantes$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((valor) => {
                this.facturasRestantes = valor;
            });
    }

    gotofolios(){
        this._router.navigateByUrl('/cuenta/perfil?key=plan-billing');
        
    }

    actualizarFacturas(cantidad: number): void {
        this.facturasRestantes = cantidad;
    }

    getNavigation = () => {
        if (this.sessionInitializer.state) {
            this.state = this.baseService.getUserData();
            this.user = this.state.user;
            this.empresas = this.state.company;
            let dtOperacion = this.baseService.getOperacionData();
            this._userService.user = {
                id: String(this.user.userName),
                name: this.user.userName, //dtOperacion?.razonSocial || '',//this.user.userName,
                email: this.user.email,
                avatar: this.logoEmpresa,
                status: 'online',
            };
            this.objSeguridad = [];
            let modulosSeguridad: IModulo[] = [];
            const _default: FuseNavigationItem[] = [];
            modulosSeguridad = this.baseService.getSecurityData().modulos;
            if (modulosSeguridad) {
                modulosSeguridad.forEach((modulo: any) => {
                    const caption = modulo.caption; //JSON.parse(modulo.caption);
                    if (caption.datos) {
                        const itemNav: FuseNavigationItem = {
                            icon: caption.datos[0].icon,
                            id: modulo.id.toString(),
                            link: modulo.link,
                            title: modulo.title,
                            type: modulo.children.length
                                ? 'collapsable'
                                : 'basic',
                            children: modulo.children,
                        };

                        _default.push(itemNav);
                        this.objSeguridad.push(caption);
                    }
                });
                this.navigation = {
                    default: _default,
                    compact: [],
                    futuristic: [],
                    horizontal: [],
                };
            }
        }
    };
    toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }
    selectEmpresa(empresa) {
        //console.log('Seleccionaste:', empresa);
        if (empresa === 'nuevaEmpresa') {
            this.empresaSeleccionada = null;
            // this._router.navigate(['/cuenta/perfil']);
            this._router.navigate(['/cuenta/newcompany']);
        } else {
            this.empresaSeleccionada = empresa;
            localStorage.setItem("empresaSeleccionada", JSON.stringify(this.empresaSeleccionada));

            // Emitir el cambio de empresa seleccionada usando el servicio
            this.empresaService.seleccionarEmpresa(this.empresaSeleccionada);

            this._router.navigate(['/factura/dashboard']);
        }
        
        this.isDropdownOpen = false;
        this.store.dispatch(
            SeleccionarEmpresa({ empresaSeleccionada: this.empresaSeleccionada })
        );
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(isNull);
        this._unsubscribeAll.complete();
    }
    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                name
            );

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }
}
